/**
 * @fileoverview Convert `<input type="date">` strings ("YYYY-MM-DD") into
 * inclusive millisecond bounds for Convex `_creationTime` filters.
 *
 * `from` snaps to the start of the local day; `to` snaps to the end of the
 * local day so a single picked date covers its whole 24h. Empty or invalid
 * input yields `undefined` (an unbounded edge).
 */

/** Start-of-day (local) ms for a "YYYY-MM-DD" string; undefined if empty/invalid. */
export function dateInputToFromMs(value: string): number | undefined {
  if (!value) return undefined;
  const d = new Date(`${value}T00:00:00`);
  return Number.isNaN(d.getTime()) ? undefined : d.getTime();
}

/** End-of-day (local) ms for a "YYYY-MM-DD" string; undefined if empty/invalid. */
export function dateInputToToMs(value: string): number | undefined {
  if (!value) return undefined;
  const d = new Date(`${value}T23:59:59.999`);
  return Number.isNaN(d.getTime()) ? undefined : d.getTime();
}
